const $$splitComponentImporter = () => import('/home/runner/work/touring-host-app/touring-host-app/src/routes/_rootLayout/companies/$id.holds.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getFindCompanyHoldsQueryOptions } from '@api';
import { createTableQuerySchema, getTableParams } from '@common*';
import { createFileRoute } from '@tanstack/react-router';
const TABLE_ID_COMPANY_UPCOMING_HOLDS = 'companyUpcomingHolds';
const TABLE_ID_COMPANY_PAST_HOLDS = 'companyPastHolds';
const searchSchema = createTableQuerySchema({
  tableIds: [TABLE_ID_COMPANY_UPCOMING_HOLDS, TABLE_ID_COMPANY_PAST_HOLDS]
});
export const Route = createFileRoute('/_rootLayout/companies/$id/holds')({
  validateSearch: search => searchSchema.parse(search),
  beforeLoad: () => ({
    tableIdCompanyUpcomingHolds: TABLE_ID_COMPANY_UPCOMING_HOLDS,
    tableIdCompanyPastHolds: TABLE_ID_COMPANY_PAST_HOLDS
  }),
  loader: async ({
    context: {
      queryClient
    },
    params,
    location
  }) => {
    const tableParamsUpcoming = getTableParams(location.search, TABLE_ID_COMPANY_UPCOMING_HOLDS);
    const tableParamsPast = getTableParams(location.search, TABLE_ID_COMPANY_PAST_HOLDS);
    queryClient.ensureQueryData(getFindCompanyHoldsQueryOptions(params.id, {
      type: 'UPCOMING',
      ...tableParamsUpcoming
    }));
    queryClient.ensureQueryData(getFindCompanyHoldsQueryOptions(params.id, {
      type: 'PAST',
      ...tableParamsPast
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});